/**
 * Created by niuzz on 17/7/16.
 */

/* 是否手机 */
export function isMobile(str) {
    if (!str) {
        return;
    }
    const reg = /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/;
    return reg.test(str.trim());
}
/* 只能正数金额 */
export function isOkMoney(str) {
    if (!str) {
        return;
    }
    const reg = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^0$)|(^\d\.\d{1,2}$)/;
    return reg.test(str);
}

/* 是否邮箱 */
export function isEmail(str) {
    const reg = /^[a-zA-Z0-9]+([._\\-]*[a-zA-Z0-9])*@([a-zA-Z0-9]+[-a-zA-Z0-9]*[a-zA-Z0-9]+\.){1,63}[a-zA-Z0-9]+$/;
    return reg.test(str.trim());
}

/* 是否alipay */
export function isAlipay(str) {
    const reg = /^\d{18}$/;
    return reg.test(str.trim());
}

/* 验证数字 */
export function isNum(str) {
    if (!str) {
        return;
    }
    const reg = /^[0-9]*$/;
    return reg.test(str.trim());
}

/* 合法uri */
export function isURL(textval) {
    const regex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
    return regex.test(textval);
}

/* 合法uri */
export function isURLHttp(textval) {
    const regex = /^(https|http)*$/;
    return regex.test(textval);
}

/* 匹配上标*/
export function isSvp(textval) {
    return textval.replace(/®/g, '<sup>®</sup>')
}

// export default {
//   // url: 'https://partnersocialtest.intel.cn/files/test/',
//   url: 'http://partnersocial.intel.cn/files',
//   // url1:' http://54.223.188.166:8084/reportTest/pc/qxsq/activity/exportByAdmin.do/?token=',  //ceshi2
//   // url1: 'https://partnersocialtest.intel.cn/apiTest/pc/qxsq/activity/exportByAdmin.do/?token=',
//   url1: 'http://partnersocial.intel.cn/api/pc/qxsq/activity/exportByAdmin.do/?token=',
// }


export function utilUrl() {
    const i = window.location.href;
    if (i == `https://partnersocial.intel.cn/report/#/list`) {
        return { url: 'https://partnersocial.intel.cn/files', url1: 'https://partnersocial.intel.cn/api/pc/qxsq/activity/exportByAdmin.do/?token=' };
    } else {
        return { url: 'https://partnersocialtest.intel.cn/files/test/', url1: 'https://partnersocialtest.intel.cn/apiTest/pc/qxsq/activity/exportByAdmin.do/?token=' };
    }
}

export function GetQueryString(name) {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
    const i = window.location.href.indexOf('?');
    const r = window.location.href.substr(i).substr(1).match(reg);

    if (r != null) return unescape(r[2]);
    return null;
}


// WEBPACK FOOTER //
// ./src/util/validator.js